/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { calculateDiscountItemGroupModifierRequestSchema } from "./calculateDiscountItemGroupModifierRequestSchema.ts";

export const mobileOrderItemGroupModifierCreateRequestSchema = calculateDiscountItemGroupModifierRequestSchema;
